import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import "bootstrap/scss/bootstrap.scss";
import "assets/scss/paper-kit.scss?v=1.3.0";
import "assets/demo/demo.css?v=1.3.0";

import App from "App";
import { store, persister } from "./store";
import staticDataManager from "managers/staticDataManager";
import { accountInitialize } from "store/accountActions";

const basename = process.env.PUBLIC_URL || "";

const langSegFromUrl = () => {
  let path = window.location.pathname;
  if (basename && path.startsWith(basename)) {
    path = path.slice(basename.length);
  }
  return path.split("/")[1]?.toLowerCase();
};

const normalize = (code) => (code || "").split("-")[0].toLowerCase();

const bootstrap = () => {
  const urlSeg = langSegFromUrl();
  const state = store.getState();

  const languages = state.staticData?.languages || [];
  if (urlSeg && languages.length) {
    const langFromUrl = languages.find((l) => normalize(l.code) === urlSeg);
    if (langFromUrl && state.account?.language?.code !== langFromUrl.code) {
      store.dispatch(accountInitialize({ language: langFromUrl }));
    }
  }

  staticDataManager(store);
};

ReactDOM.render(
  <Provider store={store}>
    <PersistGate
      loading={null}
      persistor={persister}
      onBeforeLift={bootstrap}
    >
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
